import { loadDX as loadDX_ } from './dx-loader';
import { loadZip as loadZip_ } from './zip-loader';

export namespace Loaders {
  export const loadZip = loadZip_;
  export const loadDX = loadDX_;
}
